import type { Phase } from "@offsite/shared";

/** Kanonische Workshop-Phasen-Reihenfolge (= VALID_PHASES im Backend). */
export const PHASE_ORDER: Phase[] = [
  "waiting",
  "topics",
  "voting",
  "winner-reveal",
  "grouping",
  "working",
  "submitted",
  "evaluating",
  "evaluated",
  "overnight",
  "reveal",
];

/** Nächste Phase in der Reihenfolge, oder null wenn schon die letzte. */
export function nextPhase(current: Phase): Phase | null {
  const i = PHASE_ORDER.indexOf(current);
  if (i < 0 || i === PHASE_ORDER.length - 1) return null;
  return PHASE_ORDER[i + 1];
}

export interface TallyLike {
  topicId: string;
  count: number;
}

export interface VoteTie {
  isTie: boolean;
  maxCount: number;
  tiedTopicIds: string[];
}

/**
 * Gleichstand = ≥2 Themen teilen die (positive) Höchst-Stimmenzahl.
 * Bei 0 Stimmen oder klarem Sieger: kein Gleichstand.
 */
export function detectVoteTie(tallies: TallyLike[]): VoteTie {
  let maxCount = 0;
  for (const t of tallies) if (t.count > maxCount) maxCount = t.count;
  const tiedTopicIds =
    maxCount > 0
      ? tallies.filter((t) => t.count === maxCount).map((t) => t.topicId)
      : [];
  return { isTie: tiedTopicIds.length >= 2, maxCount, tiedTopicIds };
}
